// extracted by mini-css-extract-plugin
export default {"imgProfile":"About_imgProfile__Ciaoz"};